/**
 * Created by mac on 11/3/25
 */

const LightningRushLevelsAdapter = {
    SubscribeToEvents: function () {
        if (!cleverapps.config.features.includes("lighting_rush")) {
            return;
        }

        cleverapps.eventBus.on("outcome", (outcome) => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LIGHTNING_RUSH);
            if (!mission || !mission.isRunning() || mission.isCompleted()) {
                return;
            }

            if (outcome === GameBase.OUTCOME_VICTORY) {
                mission.logic.earnPoints(Game.currentGame.rewards.lightningRush || 0);
            }
        });

        cleverapps.eventBus.on("collectMark", (value) => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_LIGHTNING_RUSH);
            if (!mission || !mission.isRunning() || mission.isCompleted()) {
                return;
            }

            const game = Game.currentGame;
            game.rewards.lightningRush = (game.rewards.lightningRush || 0) + value;
        });

        cleverapps.missionManager.on("lightningRushStart", (mission) => {
            if (mission.getType() === Mission.TYPE_LIGHTNING_RUSH) {
                mission.logic.startCompetition();
            }
        });
    }
};

cleverapps.whenAllInitialized(() => LightningRushLevelsAdapter.SubscribeToEvents());